// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const TerminalPageSelector: MarkdocTagRegistration = {
  tag: 'terminal-page-selector',
  component: 'TerminalPageSelector',
  attributes: {},
};
